import boyOnTractor from '../images/boyOnTractor.jpg'
import playRoom from '../images/playRoom.jpg'
import saloon from '../images/saloon.jpg'
import fox from '../images/fox.jpg'
import pinapple from '../images/pinapple.jpg'
import kidWithBaloon from '../images/kid-with-baloons.jpg'

const imgData = [
    {
        title: 'boy on tractor',
        imageUrl: "",
        pic: boyOnTractor,
        tagsAndPlace: [
            {
                tagName: 'head',
                startC: [200,32],
                endC: [234,83]
            },
            {
                tagName: 'boot',
                startC: [110,190],
                endC: [170,234]
            }
            // more tags info
        ],
        id: 1, //??
    },
    {
        title: 'play room',
        imageUrl: "",
        pic: playRoom,
        tagsAndPlace: [
            {
                tagName: 'red car',
                startC: [67,234],
                endC: [82,244]
            },
            {
                tagName: 'map',
                startC: [63,7],
                endC: [196,98]
            },
            {
                tagName: 'chair',
                startC: [254,110],
                endC: [304,185]
            }
            // more tags info
        ],
        id: 1, //??
    },
    {
        title: 'saloon',
        imageUrl: "",
        pic: saloon,
        tagsAndPlace: [
            {
                tagName: 'tree',
                startC: [61,119],
                endC: [148,281]
            },
            {
                tagName: 'pillow',
                startC: [203,206],
                endC: [246,245]
            },
            {
                tagName: 'lamp',
                startC: [354,107],
                endC: [426,286]
            }
            // more tags info
        ],
        id: 1, //??
    },
    {
        title: 'fox',
        imageUrl: "",
        pic: fox,
        tagsAndPlace: [
            {
                tagName: 'eyes',
                startC: [106,94],
                endC: [142,102]
            },
            {
                tagName: 'tail',
                startC: [304,138],
                endC: [353,300]
            },
            {
                tagName: 'ears',
                startC: [77,40],
                endC: [152,76]
            }
            // more tags info
        ],
        id: 1, //??
    },
    {
        title: 'pinapple',
        imageUrl: "",
        pic: pinapple,
        tagsAndPlace: [
            {
                tagName: 'sunglasses',
                startC: [150,158],
                endC: [253,186]
            },
            {
                tagName: 'green balloon',
                startC: [334,126],
                endC: [450,267]
            },
            
            // more tags info
        ],
        id: 1, //??
    },
    {
        title: 'kid with baloon',
        imageUrl: "",
        pic: kidWithBaloon,
        tagsAndPlace: [
            {
                tagName: 'yellow balloon',
                startC: [274,89],
                endC: [310,138]
            },
            {
                tagName: 'hat',
                startC: [178,113],
                endC: [222,142]
            },
            {
                tagName: 'shoes',
                startC: [192,271],
                endC: [243,282]
            },
            
            // more tags info
        ],
        id: 1, //??
    },
    // more pictures
];

export default imgData;
